// extracted by mini-css-extract-plugin
export default {"container":"sN-z","topReviewHeading":"tN-z","criticalReview":"uN-z","favorableReview":"vN-z","vsSeparator":"wN-z"};